import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "../views/Landing.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/message-from-chairman.html",
    name: "Chairman",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Chairman" */ "../views/Chairman.vue"),
  },
  {
    path: "/message-from-executive-director.html",
    name: "ED",
    component: () => import(/* webpackChunkName: "ED" */ "../views/ED.vue"),
  },
  {
    path: "/board-members.html",
    name: "BoardMembers",
    component: () => import(/* webpackChunkName: "BoardMembers" */ "../views/BoardMembers.vue"),
  },
  {
    path: "/support-to-economy.html",
    name: "SupportToEconomy",
    component: () =>
      import(/* webpackChunkName: "SupportToEconomy" */ "../views/SupportToEconomy.vue"),
  },
  {
    path: "/our-initiatives.html",
    name: "Initiatives",
    component: () => import(/* webpackChunkName: "Initiatives" */ "../views/Initiatives.vue"),
  },
  {
    path: "/holiday-at-home.html",
    name: "HolidayAtHome",
    component: () =>
      import(/* webpackChunkName: "HolidayAtHome" */ "../views/initiatives/HolidayAtHome.vue"),
  },
  {
    path: "/global-visibility-missyoutoo.html",
    name: "GlobalVisibility-MissYouToo",
    component: () =>
      import(
        /* webpackChunkName: "GlobalVisibility-MissYouToo" */ "../views/initiatives/GlobalVisibility-MissYouToo.vue"
      ),
  },
  {
    path: "/global-visibility-360.html",
    name: "GlobalVisibility-360",
    component: () =>
      import(
        /* webpackChunkName: "GlobalVisibility-360" */ "../views/initiatives/GlobalVisibility-360.vue"
      ),
  },
  {
    path: "/global-visibility-mega-event.html",
    name: "GlobalVisibility-Mega",
    component: () =>
      import(
        /* webpackChunkName: "GlobalVisibility-Mega" */ "../views/initiatives/GlobalVisibility-Mega.vue"
      ),
  },
  {
    path: "/global-visibility-super-fans.html",
    name: "GlobalVisibility-Super",
    component: () =>
      import(
        /* webpackChunkName: "GlobalVisibility-Super" */ "../views/initiatives/GlobalVisibility-Super.vue"
      ),
  },
  {
    path: "/gearing-up-the-trade-unceasing-communications.html",
    name: "GearingUpTheTrade-Uncease",
    component: () =>
      import(
        /* webpackChunkName: "GearingUpTheTrade-Uncease" */ "../views/initiatives/GearingUpTheTrade-Uncease.vue"
      ),
  },
  {
    path: "/gearing-up-the-trade-restore-confidence.html",
    name: "GearingUpTheTrade-Restore",
    component: () =>
      import(
        /* webpackChunkName: "GearingUpTheTrade-Restore" */ "../views/initiatives/GearingUpTheTrade-Restore.vue"
      ),
  },
  {
    path: "/about-us.html",
    name: "AboutUs",
    component: () => import(/* webpackChunkName: "AboutUs" */ "../views/AboutUs.vue"),
  },
  {
    path: "/worldwide-offices-&-representatives.html",
    name: "Map",
    component: () => import(/* webpackChunkName: "Map" */ "../views/Map.vue"),
  },
  {
    path: "/sitemap.html",
    name: "Sitemap",
    component: () => import(/* webpackChunkName: "Sitemap" */ "../views/Sitemap2.vue"),
  },
];

function dirname(path) {
  //  discuss at: https://locutus.io/php/dirname/
  // original by: Ozh
  // improved by: XoraX (https://www.xorax.info)
  //   example 1: dirname('/etc/passwd')
  //   returns 1: '/etc'
  //   example 2: dirname('c:/Temp/x')
  //   returns 2: 'c:/Temp'
  //   example 3: dirname('/dir/test/')
  //   returns 3: '/dir'
  return path.replace(/\\/g, "/").replace(/\/[^/]*\/?$/, "");
}

let pathname = window.location.pathname;
if (pathname.slice(-1) === "/") {
  pathname += "index.html";
}

let base_url = dirname(pathname);

// console.log(base_url);

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  base: base_url,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log(to.name, from.name, savedPosition);
    if (to && from) {
      if (from.name.substring(0, 6) != to.name.substring(0, 6)) {
        return { x: 0, y: 0 };
      } else if (to.name.substring(0, 6) && from.name.substring(0, 6) === "Global") {
        return {
          selector: ".custom-breadcrumb",
          offset: { y: 110 },
          behavior: "smooth",
        };
      } else if (to.name.substring(0, 7) && from.name.substring(0, 7) === "Gearing") {
        return {
          selector: ".custom-breadcrumb",
          offset: { y: 110 },
          behavior: "smooth",
        };
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
});

// router.beforeEach((to, from, next) => {
//   console.log("router before each")
//   next()
// })

export default router;
